var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"small-container text-center\"><p>List with a Partner Agent</p><p class=\"text-small\">If you select List with a Partner Agent, {{ $ctrl.brokerage.brokerage_name }} will recommend\na top local agent to work with you.</p></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/components/od-brokerage-info.jade
 ** module id = 3506
 ** module chunks = 3
 **/